import { Box } from '@mui/material';
import React from 'react';

export type SentimentDirection = 'positive' | 'neutral' | 'negative';

interface SentimentIndicatorProps {
  direction: SentimentDirection;
  size?: number;
}

const SENTIMENT_STYLES: Record<
  SentimentDirection,
  { background: string; inner: string; shadow: string; border: string }
> = {
  positive: {
    background:
      'radial-gradient(circle at 30% 30%, rgba(130,255,206,0.95) 0%, rgba(47,106,78,0.8) 55%, rgba(6,27,20,0.6) 100%)',
    inner: 'linear-gradient(175deg, rgba(130,255,206,0.9) 0%, rgba(36,161,110,0.9) 100%)',
    shadow: '0 0 16px rgba(130,255,206,0.45)',
    border: 'rgba(115,255,214,0.9)',
  },
  negative: {
    background:
      'radial-gradient(circle at 35% 30%, rgba(255,170,170,0.95) 0%, rgba(146,25,41,0.85) 55%, rgba(38,7,14,0.7) 100%)',
    inner: 'linear-gradient(175deg, rgba(255,186,170,0.95) 0%, rgba(176,32,48,0.95) 100%)',
    shadow: '0 0 16px rgba(255,116,116,0.45)',
    border: 'rgba(255,157,157,0.85)',
  },
  neutral: {
    background:
      'radial-gradient(circle at 30% 30%, rgba(208,186,255,0.8) 0%, rgba(68,44,120,0.9) 55%, rgba(24,18,42,0.7) 100%)',
    inner: 'linear-gradient(175deg, rgba(203,181,255,0.95) 0%, rgba(113,93,183,0.95) 100%)',
    shadow: '0 0 16px rgba(179,149,255,0.35)',
    border: 'rgba(203,181,255,0.85)',
  },
};

export const SentimentIndicator: React.FC<SentimentIndicatorProps> = ({
  direction,
  size = 16,
}) => {
  const style = SENTIMENT_STYLES[direction];
  return (
    <Box
      aria-label={`${direction} sentiment`}
      role="presentation"
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        position: 'relative',
        flexShrink: 0,
        background: style.background,
        border: `1px solid ${style.border}`,
        boxShadow: style.shadow,
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: size * 0.22,
          borderRadius: '50%',
          background: style.inner,
          boxShadow: style.shadow,
        },
      }}
    />
  );
};
